import { useState, useEffect } from "react"
import { getSearchCategories } from "../api/category/requests";


function useSearchCategories(language) {
  const [categoriesMap, setCategoriesMap] = useState({}),
        [isLoading, setIsLoading] = useState(true)

  useEffect(()=>{
    if(language) {
      setIsLoading(true);
      getSearchCategories()
        .then((data)=>{
            let categoryList = []

            if(data && data.length > 0) {
              categoryList = data.map((c,idx)=>{
                return {
                  key: idx,
                  label: c.title,
                  value: c.title
                }
              })
            }

            let newMap = {
              ...categoriesMap
            }
            newMap[language] = categoryList
            setCategoriesMap(newMap)
            setIsLoading(false)
          })
        .catch((err)=>{
          console.error(err)
          setIsLoading(false)
        })
    }
  },[language])

  return [categoriesMap[language] || [], isLoading]
}

export default useSearchCategories
